import React from 'react'
import './LoadingArea.scss'

const LoadingArea = ({ isTableLoader = false }) => {
	// const getLocale = useComponentLocale()
	// const loadingLocale = getLocale({ component: 'common', section: 'loading' })

	return (
		<div className={'loading-area' + (isTableLoader ? ' loading-area_table' : '')}>
			<p>
				<svg
					width='50'
					height='50'
					viewBox='0 0 50 50'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
					className='newLoader'
					style={{
						translate: 'none',
						rotate: 'none',
						scale: 'none',
						transform: 'translate3d(0px, 0px, 0px)',
					}}
				>
					<path
						d='M48 25c0 12.703-10.297 23-23 23S2 37.703 2 25 12.297 2 25 2s23 10.297 23 23z'
						stroke='#43e090'
						strokeWidth='3'
						style={{
							strokeDashoffset: 1.1e-5,
							strokeDasharray: '35.7352px, 108.899px',
						}}
					/>

					<path
						d='M2 25C2 12.297 12.297 2 25 2s23 10.297 23 23-10.297 23-23 23S2 37.703 2 25z'
						stroke='#43e090'
						strokeWidth='3'
						style={{
							strokeDashoffset: 1.1e-5,
							strokeDasharray: '35.7352px, 108.899px',
						}}
					></path>
				</svg>
			</p>
		</div>
	)
}

export default LoadingArea
